export const HOMEPAGE_VIDEOS_KEY = ['home', 'videos'];

/**
 * Cache key for GET /videos/next. One entry per video, kept for the session
 * so moving back and forth never repeats a request. The server picks the
 * playlist from the user's audience, so the video id is the whole key.
 *
 * @param {string} videoId - YouTube video id
 */
export function nextVideoKey(videoId) {
  return ['videos', 'next', videoId];
}
